/** @format */

import styled from "styled-components";
import { colors, mixins, fonts } from "../../../css/variables";
import { ErrorMessage, InquiryStatusIcon, InquiryCommentItems } from "../../ui-parts";
import useInquiryItemHooks from "../../../hooks/useInquiryItemHooks";
import InquiryFileElement from "./InquiryFileElement";
import ZeusIcon from "../../../images/icon_zeus.svg";
import { inquiryCommentArrayType } from "../../../constance/providerTypeModel";
import useNavigateByAgent from "../../../hooks/useNavigateByAgentHooks";

type wholeWrapperStyleType = {
  navigation?: boolean;
};
const WholeWrapperStyle = styled.div<wholeWrapperStyleType>`
  background: ${colors.themeColor("background_main")};
  ${(props) => (!props.navigation ? "border-radius: 8px;" : "")}
  border: solid 1px ${colors.themeColor("border_box")};
`;

type titleWrapperStyleType = {
  toggle?: boolean;
  navigation?: boolean;
};
const TitleWrapperStyle = styled.div<titleWrapperStyleType>`
  display: flex;
  align-items: center;
  padding: ${(props) => (props.navigation ? "8px 0px 8px 20px" : "16px 0px 16px 28px")};
  cursor: pointer;
  ${(props) =>
    !props.toggle || !props.navigation ? "border-bottom: solid 1px" + colors.themeColor("border_box") : null};
  .toggleArrow {
    width: 60px;
    height: 28px;
    position: relative;
    transition: all 0.3s linear;
    ${(props) => (props.toggle ? "transform: rotate(180deg)" : null)};
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -15%) rotate(-45deg);
      width: 12px;
      height: 12px;
      border-top: solid 2px ${colors.themeColor("text_lightgray")};
      border-right: solid 2px ${colors.themeColor("text_lightgray")};
    }
  }
`;

type contentWrapperStyleType = {
  test?: boolean;
  navigation?: boolean;
};
const ContentWrapperStyle = styled.div<contentWrapperStyleType>`
  display: ${(props) => (props.test ? "block" : "none")};
  ${(props) => (props.navigation ? "max-height:400px;" : "")}
  ${(props) => (props.navigation ? "overflow: scroll;" : "")} 
  ${(props) => (props.navigation ? "-ms-overflow-style: none;" : "")} 
  ${(props) => (props.navigation ? "scrollbar-width: none;" : "")} 
  ::-webkit-scrollbar {
    display: none;
  }
`;

type contentInnerStyleType = {
  navigation?: boolean;
};
const ContentInnerStyle = styled.div<contentInnerStyleType>`
  ${(props) => (props.navigation ? "padding: 0 20px 20px 20px;" : "padding: 0 28px 28px 28px;")}
`;

type contentInputStyleType = {
  height?: number;
};
const ContentInputStyle = styled.div<contentInputStyleType>`
  padding: 16px;
  margin-top: 28px;
  border: 1px solid ${colors.themeColor("border_box")};
  background: ${colors.themeColor("background_whitegray")};
  border-radius: 4px;
  .textarea {
    -webkit-appearance: none;
    border: 1px solid ${colors.themeColor("border_box")};
    padding: 12px 16px;
    border-radius: 4px;
    outline: none;
    resize: vertical;
    width: 100%;
    height: ${(props) => props.height + "px"};
    display: block;
    min-height: 120px;
    max-height: 300px;
    &:focus {
      border: 1px solid ${colors.themeColor("primary_light")};
    }
    ::-webkit-resizer {
      display: none;
    }
  }
`;
const SlideInWrapper = styled.div``;
type titlePType = {
  navigation?: boolean;
  ItemToggle?: boolean;
};
const TitleP = styled.p<titlePType>`
  font-size: ${(props) => (props.navigation ? fonts.fontSizeRem("s") : fonts.fontSizeRem("xl"))};
  font-weight: 600;
  margin-right: auto;
  margin-bottom: 0px;
  margin-left: 12px;
  ${(props) => (props.navigation ? (props.ItemToggle ? "width:360px;" : "width:200px;") : "")}
  ${(props) =>
    props.navigation &&
    "white-space: nowrap; overflow: hidden; text-overflow: ellipsis; -webkit-text-overflow: ellipsis; -o-text-overflow: ellipsis;"} 
  ${mixins.screenUnder()} {
    font-size: ${fonts.fontSizeRem("m")};
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
`;
const IconWrapperStyle = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 30px;
  background: ${colors.themeColor("background_whitegray")};
  border: solid 1px ${colors.themeColor("border_box")};
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IconStyle = styled.img`
  width: 30px;
  height: 24px;
  overflow: visible;
`;
const InquiryItemElement = ({
  inquiryData,
  inquiryComment,
  accordionOpen,
  navigation,
}: {
  inquiryData: {
    status: string;
    title: string;
    ticket_id: number;
  };
  inquiryComment: inquiryCommentArrayType;
  accordionOpen: number | null;
  navigation?: boolean;
}) => {
  const { navigateByAgent } = useNavigateByAgent();
  const {
    ItemToggle,
    itemToggleChangeHandler,
    toggleRef,
    NavToggleRef,
    ScrollHeight,
    scrollHeightChangeHandler,
    TextareaRef,
    commentRegisterHandler,
    isFlag,
    CommentRegisterErrMsg,
    FileDatas,
    setFileData,
    canceledFlag,
  } = useInquiryItemHooks(accordionOpen, inquiryData.ticket_id, navigation, navigateByAgent);

  return (
    <WholeWrapperStyle navigation={navigation}>
      {!navigation && (
        <>
          {/* 常に表示している部分 */}
          <TitleWrapperStyle onClick={itemToggleChangeHandler} toggle={ItemToggle} navigation={navigation}>
            <InquiryStatusIcon status={inquiryData.status} navigation={navigation} />
            <TitleP ItemToggle={ItemToggle} navigation={navigation}>
              {inquiryData.title}
            </TitleP>
            <div className="toggleArrow active"></div>
          </TitleWrapperStyle>
          {/* アクティブ時のみ表示する部分 */}
          <ContentWrapperStyle navigation={navigation} test={isFlag} ref={toggleRef}>
            <ContentInnerStyle>
              {/* コメント表示部分 */}
              <InquiryCommentItems commentData={inquiryComment} />
              <ContentInputStyle height={ScrollHeight + 2}>
                <textarea
                  ref={TextareaRef}
                  id="textarea"
                  onChange={scrollHeightChangeHandler}
                  className="textarea"
                  placeholder="返信"
                  disabled={inquiryData.status === "CLOSED" || canceledFlag ? true : false}
                ></textarea>
                <ErrorMessage ApiErrMsg={CommentRegisterErrMsg} />
                {/* ファイルの表示部分 */}
                <InquiryFileElement
                  registerHandler={commentRegisterHandler}
                  ticket_id={inquiryData.ticket_id}
                  status={inquiryData.status}
                  FileDatas={FileDatas}
                  setFileData={setFileData}
                  maxsize={30}
                />
              </ContentInputStyle>
            </ContentInnerStyle>
          </ContentWrapperStyle>
        </>
      )}
      {navigation && (
        <>
          {/* 常に表示している部分 */}
          <TitleWrapperStyle onClick={itemToggleChangeHandler} toggle={ItemToggle} navigation={navigation}>
            <IconWrapperStyle>
              <IconStyle src={ZeusIcon} />
            </IconWrapperStyle>
            <TitleP ItemToggle={ItemToggle} navigation={navigation}>
              {inquiryData.title}
            </TitleP>
            <div className="toggleArrow active"></div>
          </TitleWrapperStyle>

          <ContentWrapperStyle navigation={navigation} test={isFlag} ref={NavToggleRef}>
            <ContentInnerStyle navigation={navigation}>
              <InquiryCommentItems commentData={inquiryComment} navigation={navigation} />
              <SlideInWrapper>
                <ErrorMessage ApiErrMsg={CommentRegisterErrMsg} />
                {/* ファイルの表示部分 */}
                <InquiryFileElement
                  registerHandler={commentRegisterHandler}
                  ticket_id={inquiryData.ticket_id}
                  status={inquiryData.status}
                  FileDatas={FileDatas}
                  setFileData={setFileData}
                  textareaRef={TextareaRef}
                  textareaChange={scrollHeightChangeHandler}
                  navigation={navigation}
                  maxsize={30}
                />
              </SlideInWrapper>
            </ContentInnerStyle>
          </ContentWrapperStyle>
        </>
      )}
    </WholeWrapperStyle>
  );
};

export default InquiryItemElement;
